// Libs
import React, { useState, useEffect } from "react";
import moment from "moment";
import { Modal, Button } from "react-bootstrap";

// Components & Utils
import MealPlanApi from "../api/MealPlans";
import { useGlobalValue } from "../utils/GlobalState";
import { setIsLoading, setErrors } from "../utils/Actions";

export default function CancelMealModal(props) {
  // State
  const [, dispatch] = useGlobalValue();
  const [type, setType] = useState(0);

  useEffect(() => {
    if (props.meal) {
      setType(+props.meal.cancelled);
    }
  }, [props]);

  if (!props.meal) {
    return <></>;
  }

  const date = moment(props.meal.date, "YYYY-MM-DD");

  const cancelMeal = () => {
    setIsLoading(true, dispatch);

    const planType = props.meal.type === 0 ? 1 : 2;
    MealPlanApi.cancelMeal(planType, props.meal.entry_id, date)
      .then(() => {
        setIsLoading(false, dispatch);
        dispatch({
          type: "setRefresh",
          refresh: true
        });
        props.hide();
      })
      .catch(apiError => {
        setIsLoading(false, dispatch);
        setErrors(apiError, dispatch);
      });
  };

  return (
    <Modal show={props.show} onHide={props.hide}>
      <Modal.Header>
        <Modal.Title>{type === 1 ? "Un-Cancel" : "Cancel"} Meal</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure you want to {type === 1 ? "un-cancel" : "cancel"} <b>{props.meal.meal.name}</b> on{" "}
        {date.format("dddd Do MMMM")}
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.hide}>Cancel</Button>
        <Button variant="success" onClick={() => cancelMeal()}>
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
